<template>
  <div :class="{ error: hasErrors }">
    <slot />
    <div class="errors" v-if="hasErrors">
      <div
        class="error form-required"
        v-for="error in activeErrors"
        :key="error.validationKey"
      >
        {{
          $t(getErrorMessage(error.validationKey, error.params), error.params)
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
  mixins: [singleErrorExtractorMixin],
};
</script>
